import { makeTranslationHelpers } from '@/hooks/useTranslation';

const { useTranslation: useHealthTranslations, Translation } =
  makeTranslationHelpers('page.companyReport.health');

export { useHealthTranslations, Translation as HealthTranslation };
